import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {entityRotasFeatureKey, reducer} from './entity-rota.reducer';
import {EffectsModule} from '@ngrx/effects';
import {EntityRotaEffects} from '~entity/entity-rota/entity-rota.effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(entityRotasFeatureKey, reducer),
    EffectsModule.forFeature([EntityRotaEffects]),
  ],
})
export class EntityRotaModule {
}
